import { ISearchElementStyle } from './searchPageConfig';

// Consumer-side mirror of the admin editor's bundle page config
// (ac-main/web: components/Storefront/Editor/bundlePageConfig.ts). Persisted as a single JSON
// string on IStorefrontSettings.bundlePageConfig. Each section is a bag of CSS props (ISearchElementStyle)
// applied to a bounding component of the bundle page via elementStyleFrom. Absent config = zero
// inline styles (the page renders exactly as before), so this is strictly additive.
export interface IBundlePageConfig {
    // The page's main content wrapper (max-width column).
    container?: ISearchElementStyle;
    // The bundle name heading.
    title?: ISearchElementStyle;
    // The bundle image area.
    image?: ISearchElementStyle;
    // The bundle price.
    price?: ISearchElementStyle;
    // The quantity input field.
    quantity?: ISearchElementStyle;
    // The "included products" table.
    includedTable?: ISearchElementStyle;
    // The primary "Add to Cart" call-to-action button.
    addToCartButton?: ISearchElementStyle;
    // The "Add to Cart" text label beside that button. Defaults to a white pill with green text;
    // override to fit non-green themes.
    addToCartLabel?: ISearchElementStyle;
    // The bundle description block.
    description?: ISearchElementStyle;
    // Behavior flag (not a style section): when true, the description is clamped to
    // descriptionCollapsedHeight with a "Show more / Show less" toggle. When false/absent it
    // renders in full exactly as before.
    descriptionCollapsible?: boolean;
    // Collapsed height in px used when descriptionCollapsible is true (default 160).
    descriptionCollapsedHeight?: number;
}

export const BUNDLE_PAGE_SECTIONS = [
    'container', 'title', 'image', 'price', 'quantity',
    'includedTable', 'addToCartButton', 'addToCartLabel', 'description',
] as const;

export const DEFAULT_BUNDLE_PAGE_CONFIG: IBundlePageConfig = {};

export function parseBundlePageConfig(raw?: string): IBundlePageConfig {
    if (!raw) return { ...DEFAULT_BUNDLE_PAGE_CONFIG };
    try {
        return { ...DEFAULT_BUNDLE_PAGE_CONFIG, ...(JSON.parse(raw) as IBundlePageConfig) };
    } catch {
        return { ...DEFAULT_BUNDLE_PAGE_CONFIG };
    }
}
